import { useLanguage } from '../../i18n/LanguageContext';
import { siteContent } from '../../data/siteContent';
import { PageHero, Surface } from '../../components/SitePrimitives';

const ApproachBlock = ({ content }) => (
    <Surface className="overflow-hidden">
        <img src={content.image} alt="" className="h-56 w-full object-cover sm:h-72" />
        <div className="space-y-5 p-7 text-base leading-8 text-stone-600 sm:p-10">
            <h2 className="text-3xl font-medium tracking-tight text-brown-50">{content.title}</h2>
            {content.paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
        </div>
    </Surface>
);

const About = () => {
    const { language } = useLanguage();
    const page = siteContent[language].pages.approach;

    return (
        <main className="bg-nude-50">
            <PageHero image="/assets/brief/about.jpeg" title={page.title} />
            <div className="mx-auto grid max-w-6xl gap-6 px-5 py-16 sm:px-8 sm:py-24 lg:grid-cols-2">
                <ApproachBlock content={page.neuropsychology} />
                <ApproachBlock content={page.psychology} />
            </div>
        </main>
    );
};

export default About;
